<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-truck"/>
          <strong>
            {{title}}
            <b-spinner v-if="loading" class="float-right" small/>
          </strong>
        </div>
        <div>
          <create-content :form="form" ref="create-content"/>
          <b-button variant="primary"
                    :disabled="!checkCompletedPallet||loading"
                    class="float-right" @click="onSubmit">
            <span class="mr-1">Guardar</span>
            <b-spinner v-if="loading" variant="light" class="float-right" small/>
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
  import createContent from './CreateContent.vue'
  import {mapState, mapGetters} from 'vuex';

  export default {
    name: "MainForm",
    components: {
      createContent
    },
    data() {
      return {
        title: "Ingreso",
        loading: false,
        form: {
          company: {
            company_name: null,
            text: null,
            address1: null,
            address2: null,
            phone: null,
          },
          document_date: null,
          document_number: null,
          document_kilograms: 0,
          document_type: null,
          pallet_quantity: null,
          pallet_type: 'BINS',
          product: {
            fruit_code: null
          },
          container: {
            material_weight : null,
            text : null,
            finished_product: false,
            gross_weight: "0",
            id: 1,
            net_weight: "0",
          },
          material_weight:0,
        },
      }
    },
    destroyed(){
      this.$store.dispatch('bagnoArrivalModule/removeAll');
    },
    computed: {
      ...mapGetters('bagnoArrivalModule', ['checkCompletedPallet']),
      ...mapState('bagnoArrivalModule', ['items']),
    },
    methods: {
      async saveDocument() {
        const thisV = this;
        thisV.loading = true;
        const data = {
          items: thisV.items,
          company_id: thisV.form.company.id,
          document_number: thisV.form.document_number,
          document_kilograms: thisV.form.document_kilograms,
          document_type: thisV.form.document_type.value,
          pallet_type: thisV.form.pallet_type,
          date: thisV.form.document_date,
          lot: thisV.items[0].lot
        };
        try {
          const response = await thisV.$axios({
            method: "POST",
            url: "bagno/document/save_document/",
            headers: {
              "Content-Type": "application/json"
            },
            data
          });
          thisV.loading = false;
          thisV.$swal.fire(
                          'Operación realizada con éxito',
                          '',
                          'success'
                        );
          thisV.$store.dispatch('bagnoArrivalModule/removeAll');
          thisV.$router.push({name: 'bagno-recepcion-listado'});
        } catch (error) {
          console.log(error);
          thisV.loading = false;
        }
      },
      onSubmit() {
        this.saveDocument();
      }
    }
  }
</script>

<style scoped>

</style>
